// import isMobile from '../../utility/is-mobile';

export default class InfographicFlow {
  constructor() {
      let $infographicFlow = $('.infografic-flow');
      let that = this;

      if ($infographicFlow.length) {
          $(window).on('resize load', () => that.restyleOnResize($infographicFlow));
      }
  }

  restyleOnResize(element: JQuery<HTMLElement>) {
      let $element = $(element),
          elementWidth = $(element).innerWidth(),
          $flowSectionArrows = $element.find('.flow-section-arrow'),
          $flowSectionArrowsWhite = $element.find('.flow-section-arrow--white'),
          leftRightBorder = elementWidth / 2,
          borderTop = leftRightBorder / 2,
          $thirdSection = $element.find('.flow-section--third');

      if (elementWidth < 794) {
          $element.addClass('infografic-flow--vertical');
          $flowSectionArrows.css('border-top-width', borderTop);
          $flowSectionArrows.css('border-left-width', leftRightBorder);
          $flowSectionArrows.css('border-right-width', leftRightBorder);
          $flowSectionArrows.css('bottom', -borderTop + 1);
          $flowSectionArrowsWhite.css('bottom', -borderTop + 3);
          $thirdSection.css('padding-top', borderTop + 10);
      } else {
          if ($element.hasClass('infografic-flow--vertical')) {
              $element.removeClass('infografic-flow--vertical');
              $flowSectionArrows.removeAttr('style');
              $thirdSection.removeAttr('style');
          }
      }
  }
}
